{
    "style": "path",
    "size": 12,
    "path": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z",
    "colour": "#ff0000ff",
    "xOffset": 5,
    "yOffset": 6
}
